(function () {
  'use strict';
  angular.module('ringbaPortal').component('passwordInput', {
    bindings: {
      autoFocus: '<',
      formObject: '<',
      setPassword: '&'
    },
    controller: PasswordInputController,
    controllerAs: 'vm',
    templateUrl: '/scripts/shared/components/password-input/password-input.view.html'
  });

  function PasswordInputController(

  ) {
    'ngInject';

    const vm = this;
    vm.onChangePassword = onChangePassword;

    function onChangePassword() {
      if (vm.password === vm.confirmPassword) {
        vm.setPassword({
          data: {
            password: vm.password,
            confirmPassword: vm.confirmPassword
          }
        });
      }
    }


  }
})();
